import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';
import {formatDate, getUserNameFromString} from '../../../services/common';
import {buildRoute} from '../../../configs/routes';
import URL_MAP from '../../../constants/urls';
import audioNotification from '../../../assets/files/audio-notification.mp3';
import defaultUser from '../../../assets/images/required/user.png';
import {ActionDeclineInviteVideosession, ActionAcceptInviteVideosession, ActionCancelInviteVideosession} from '../../../store/actions/actions-videosession';
import socketService from '../../../services/socket';

class ModalVideoSessionInite extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center call-video',
      closeButton: true,
      keyboard: true,
    });
  }

  componentDidMount() {
    this.audioNotification();
  }

  audioNotification = () => {
    const audio = new Audio(audioNotification);
    audio.play();
  };

  cancelInvite = () => {
    const {user, sessionId} = this.props;
    this.props.ActionModalHide();
    // this.props.ActionDeclineInviteVideosession(sessionId);
    socketService.getSocket('backendS').emit('conference-invite-user-declined', {room: sessionId, user: user._id});
  };

  acceptInvite = () => {
    const {inviteUrl, sessionId} = this.props;
    this.props.ActionModalHide();
    this.props.ActionRouteNavigate(buildRoute(inviteUrl, sessionId));
  };

  render() {
    const {date, invitedBy} = this.props;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <h3 className="logout-title">Приглашение на видеосессию</h3>
            <div className="send-panel-inner">
              <div className="text-call intro">Вам отправлено приглашение на видеосессию.</div>
              <div className="send-time date">
                <span className="text-call">Дата и время:</span>
                &nbsp;
                {formatDate(date)}
              </div>
              <div className="send-name">
                <span className="text-call">От пользователя:</span>
                <div className="image-wrap">
                  <div className="user-image">
                    <img src={invitedBy.photoUrl || defaultUser} alt="" />
                  </div>
                </div>
                {getUserNameFromString(invitedBy.name, true)}
              </div>
            </div>
            <div className="logout-btn-wrap">
              <button
                type="button"
                onClick={this.cancelInvite}
                className="btn btn-conture btn-block"
              >
                Отклонить
              </button>
              <button
                type="button"
                onClick={this.acceptInvite}
                className="btn btn-base btn-block"
              >
                Принять
              </button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalVideoSessionInite.defaultProps = {
  invitedBy: {},
};

ModalVideoSessionInite.propTypes = {};

function mapStateToProps({rUser}) {
  return {
    user: rUser,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionRouteNavigate,
    ActionDeclineInviteVideosession,
    ActionAcceptInviteVideosession,
    ActionCancelInviteVideosession,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalVideoSessionInite);
